/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_H2_LeadInputs */

const es_landing_law_h2_lead = /** @type {(inputs: Landing_Law_H2_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ley cambió. Tu barco privado ya puede `)
};

const gl_landing_law_h2_lead = /** @type {(inputs: Landing_Law_H2_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lei cambiou. O teu barco privado xa pode `)
};

const en_landing_law_h2_lead = /** @type {(inputs: Landing_Law_H2_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The law changed. Your private boat can now be `)
};

/**
* | output |
* | --- |
* | "The law changed. Your private boat can now be" |
*
* @param {Landing_Law_H2_LeadInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_h2_lead = /** @type {((inputs?: Landing_Law_H2_LeadInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_H2_LeadInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_h2_lead(inputs)
	if (locale === "en") return en_landing_law_h2_lead(inputs)
	return es_landing_law_h2_lead(inputs)
});